
import React from 'react';
import propTypes from 'prop-types';
import $ from 'zzc-zepto';
import './index.css';
// import * as tripParamsHelper from '../../helpers/tripParams';
import {connect} from 'react-redux';
import classNames from 'classnames';
import { sendStatsEvent } from '../../components/statistics';


class ChoosedCitiesFooterContainer extends React.Component {
  static propTypes = {
    onSubmit: propTypes.func.isRequired,
    buttonText: propTypes.string.isRequired,
    allowEmpty: propTypes.bool,
  };

  render() {
    let {choosedCityList, buttonText, onSubmit, allowEmpty} = this.props;

    return (
      <ChoosedCitiesFooter
        cityList={choosedCityList}
        removeCity={this.removeCity}
        onSubmit={onSubmit}
        buttonText={buttonText}
        allowEmpty={allowEmpty} />
    );
  }

  componentDidUpdate(){
    // 滚动显示最后添加的城市
    if(!this.$scrollEl){
      this.$scrollEl = $('.choosed-city-wrap');
    }
    this.$scrollEl.scrollLeft(0);
  }

  /**
   * 移除城市
   */
  removeCity = (index, city) => {
    sendStatsEvent('trip_citydelete_click');
    // let {tripParams, editParams} = this.props;
    // tripParams = tripParamsHelper.removeCity(tripParams, index);
    // editParams(tripParams);
    this.props.handleRemoveCity(index, city);
  };
}


ChoosedCitiesFooter.propTypes = {
  cityList: propTypes.array.isRequired,
  removeCity: propTypes.func.isRequired,
  onSubmit: propTypes.func.isRequired,
  buttonText: propTypes.string.isRequired
};
ChoosedCitiesFooter.defaultProps = {
  cityList: [],
  allowEmpty: false
};

function ChoosedCitiesFooter(props){
  let { cityList, removeCity, onSubmit, buttonText, allowEmpty } = props;
  let buttonClass = classNames('button', {
    save: cityList && cityList.length,
    disable: allowEmpty ? false : (cityList && !cityList.length)
  });

  return(
    <div className="footer-btn">
      <ChoosedCities cityList={cityList} removeCity={removeCity}/>
      <button
        className={buttonClass}
        onClick={onSubmit}>
        {buttonText}
        {!!cityList.length && `(${cityList.length})`}
      </button>
    </div>
  );
}


ChoosedCities.propTypes = {
  cityList: propTypes.array.isRequired,
  removeCity: propTypes.func.isRequired
};

function ChoosedCities(props){
  let { cityList, removeCity } = props;

  if(!cityList.length){
    return (
      <div className="choosed-text" id="target"><p>未选择任何城市</p></div>
    );
  }

  let listView = cityList.map((city, index)=>{
    let key = index + '' + city.city;
    return (
      <li
        key={key}
        className="choosed-city-item"
        onClick={()=>{ 
          removeCity(index, city);
        }}>
        {city.cn_name}
        <i className="icon icon-close-new"></i>
      </li>
    );
  });

    

  return(
    <div className="choosed-city" id="target">
      <div className="choosed-city-wrap">
        <ul className="choosed-city-list">
          {listView.reverse()}
        </ul>
      </div>
    </div>
  );
}


export default connect(function (state, ownProps) {
  return ownProps;
})(ChoosedCitiesFooterContainer);



// WEBPACK FOOTER //
// ./src/components/ChoosedCitiesFooter/index.js